<template>
  <span style="width: 100%" class="a_c_p">
    <label-input-autocomplete v-bind="$attrs" v-on="$listeners" :label="label" @focus="focusAutocomplete($attrs)" @blur="blurAutocomplete($event)">

    </label-input-autocomplete>
    <span class="com-name-icons" :class="{'_tops': isTop}" v-if="isLoad">
        <svg-icon name="icon-16-drop-down (1)" style="width: 16px; height: 16px;color: #7f8596"></svg-icon>
    </span>
    <span class="svg-box">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <g fill="none" fill-rule="evenodd">
          <g>
            <path d="M0 0H16V16H0z" />
            <path
              fill="#7F8596"
              fill-rule="nonzero"
              d="M7 1c3.314 0 6 2.686 6 6 0 1.424-.496 2.732-1.325 3.761l2.8 2.8-1.414 1.414-2.884-2.884C9.256 12.667 8.167 13 7 13c-3.314 0-6-2.686-6-6s2.686-6 6-6zm0 2C4.79 3 3 4.79 3 7s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
            />
          </g>
        </g>
      </svg>
    </span>
  </span>
</template>

<script>
import LabelInputAutocomplete from "@/components/label-input-v2/input-autocomplete";
// import moment from "moment-timezone";
export default {
  name: "datePicker",
  props: {
    inputWidth: {
      required: false,
      default: "",
    },
    type: {
      type: String,
      required: false,
      default: "date",
    },
    format: {
      type: String,
      required: false,
      default: "HH:mm",
    },
    valueFormat: {
      type: String,
      required: false,
      default: "timestamp",
    },
    form: {
      type: Object,
      require: true,
      default: function () {
        return {};
      },
    },
    currentIndex: {
      type: [Number, String],
      require: false,
      default: '',
    },
    label: {
      type: String,
      require: false,
      default: "",
    },
    isLoad: {
      typeof: Boolean,
      require: false,
      default: false
    }
  },
  data() {
    return {
      isColor: false,
      isTop: false
    };
  },
  watch: {
    form: {
      handler(news) {
        // console.log(news.date,'71')
        if (news) {
          this.$forceUpdate();
          this.isColor = false;
        }
      },
    },
    deep: true,
  },
  methods: {
    blurAutocomplete() {
      this.isTop = false
    },
    focusAutocomplete() {
      this.isTop = true
    },
    dateFocus() {
      this.isColor = true;
      try {
        document
          .querySelectorAll(".popper__arrow")
          .forEach((item) => (item.style = `display: none`));
        document
          .querySelectorAll("th")
          .forEach((item) => (item.style = `color:#b2b6c0;`));
        document
          .querySelectorAll("td")
          .forEach(
            (item) =>
              (item.children[0].children[0].style = `font-weight: bold;`)
          );
        document
          .querySelectorAll(".el-range-editor")
          .forEach((item) => (item.style = `padding: 0 10px;`));
        document
          .querySelectorAll(".el-range-separator")
          .forEach((item) => (item.style = `display: block`));
      } catch (error) {
        //  eslint-disable-next-line
      }
    },
    dateBlur() {
      this.$forceUpdate();
      this.isColor = false;
      if (this.form) {
        // document.querySelectorAll('.el-icon-date').forEach(item => item.style = `display: block`)
        document
          .querySelectorAll(".el-range-separator")
          .forEach((item) => (item.style = `display: block`));
      } else {
        document
          .querySelectorAll(".el-icon-date")
          .forEach((item) => (item.style = `display: none`));
        document
          .querySelectorAll(".el-range-separator")
          .forEach((item) => (item.style = `display: none`));
      }
    },
  },
  components: { LabelInputAutocomplete },
};
</script>

<style lang="scss" scoped>
._tops {
  transform: rotate(180deg);
  transition: .5s;
}
.aaa {
  margin-top: 70px;
}
span {
  display: inline-block;
  position: relative;
}

.svg-box {
  position: absolute;
  top: 12px;
  right: 12px;
}
::v-deep {
  .el-autocomplete {
    width: 100%;
  }
}
.com-name-icons {
  position: absolute;
  right: 10px;
  top: 10px;
  
}

</style>
